import axios from "axios";

export const chatbotApi = axios.create({
  baseURL: process.env.REACT_APP_CHATBOT_BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
